<template>
  <div>
    <input
        :min="min"
        :value="getMaskValue(value)"
        @keydown="keydown"
        @change="onChange"
        :id="id"
        :data-row="dataRow"
        :data-col="dataCol"
        :data-time="dataTime"
        :disabled="disabled"
        @input="handleInput"
        :style="styles"
        @blur="isInputActive = false"
        @focus="isInputActive = true"
    />
  </div>
</template>

<script>
export default {
  name: 'c-textbox-float',
  inheritAttrs: true,
  props: {
    icon: {
      type: String,
      default: 'Table'
    },
    styles: {
      type: String,
      default: 'text-align: right; width: 70px; outline: none;'
    },
    value: {
      type: [String,Number],
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    },
    dataRow: {
      type: [String, Number],
      default: ''
    },
    dataCol: {
      type: [String, Number],
      default: ''
    },
    dataTime: {
      type: [String, Number],
      default: ''
    },
    min: {
      type: [String, Number],
      default: ''
    },
  },
  data: () => {
    return {
      isInputActive: false,
    }
  },
  methods: {
    onChange: function ($event) {
      this.$emit('change', $event, this.dataRow);
      this.handleInput($event);
    },
    handleInput: function ($event) {
      let val = Math.floor(parseFloat($event.target.value)*100)/100
      if(isNaN(val)){
        val = '';
      }
      // console.log("input444", val);
      this.$emit('input', val);
    },

    keydown: function (target) {
      this.$emit('keydown', target);
    },
    keyup: function (target) {

      this.$emit('keyup', target);
    },
    getMaskValue: function (value) {
      if(isNaN(value)){
        return ''
      }
      if(this.isInputActive){
          return value
      }
      value = this.getFloatValue(value);
      if(value === null || value === ''){
        return '';
      }
      value = value.toLocaleString('vi-VN');
      if(value == 'NaN'){
        return ''
      }
      // console.log(value);
      return value
    },
    getFloatValue: function (value) {
      if(value != undefined){
        value = value.toString().replace(/[^\d.-]/g, '');
        value= Math.floor(parseFloat(value)*100)/100
      }

      if(isNaN(value)){
        return '';
      }
      return value
    },
  }
}
</script>
